import { countBy } from 'lodash';

import { getQuickQuoteBatches } from 'components/Kit/EmailSuggestions/utils/suggestionFormatters';
import { SuggestedQuoteChange } from 'types/suggestions/QuoteSuggestions';

import { HANDLED_GROUP_STATES } from '../constants';
import {
  HandledGroupState,
  HandledQuoteGroupsData,
  PartitionedQuoteRequests,
  QuoteHandledState,
} from '../types';
import { deriveHandledState } from './deriveHandledState';

/**
 * Splits quote requests into active lanes and handled groups.
 * Handled lanes stay grouped by source email, with input order preserved.
 */
export function partitionQuoteRequests(
  suggestions: SuggestedQuoteChange[]
): PartitionedQuoteRequests {
  const active: SuggestedQuoteChange[] = [];
  const handledLanes: Record<HandledGroupState, SuggestedQuoteChange[]> = {
    [QuoteHandledState.Replied]: [],
    [QuoteHandledState.Quoted]: [],
    [QuoteHandledState.Skipped]: [],
  };

  for (const suggestion of suggestions) {
    const state = deriveHandledState(suggestion);
    if (state === QuoteHandledState.Active) {
      active.push(suggestion);
    } else {
      handledLanes[state].push(suggestion);
    }
  }

  const handled = Object.fromEntries(
    HANDLED_GROUP_STATES.map((state) => [
      state,
      getQuickQuoteBatches(handledLanes[state]),
    ])
  ) as HandledQuoteGroupsData;

  return {
    active,
    handled,
    laneCountByEmailID: countBy(suggestions, (s) => s.emailID),
  };
}
